import Vue from 'vue';
import store from './store/index';
import index from './index.vue';
import FinExplorer from './components/FinExplorer.vue';
import {clickOutside, clickOutsideUnbind } from './js/clickoutside';
require('./less/styles.less');

const routes = [{ path: '/', component: FinExplorer }];

const router = new VueRouter({
    mode: "hash",
    hashbang: true,
    history: true,
    scrollBehavior (to, from, saved) {
            return { x: 0, y: 0}
    },
    routes // short for routes: routes
    
});

router.afterEach((to, from) => {
    window.scrollTo(0, 0);
});

const app = new Vue({router, store, ...index });

if (window.AUTO_MOUNT !== false) {
    const appEl = document.getElementById('app');
    if (appEl){
        app.$mount('#app');
    }
}

window.finexplorerapp = app;

// Custom directives
Vue.directive('click-outside', {
    bind: clickOutside,
    unbind: clickOutsideUnbind,
});
